import dayjs from 'dayjs';

export const capitalizeString = (row: string | undefined = '') => {
  return row?.charAt(0).toUpperCase() + row?.slice(1);
};

export const renderDate = (date: string, format = "DD MMM 'YY") => {
  return date ? dayjs(date).format(format) : '';
};

export const renderCurrency = (value: number | string = 0, lang = 'nor', currency = 'nok') => {
  if (value == null) return '';
  const numberFormat = new Intl.NumberFormat(lang, {
    style: 'currency',
    minimumFractionDigits: 0,
    maximumFractionDigits: 5,
    currency,
    currencyDisplay: 'narrowSymbol',
  });
  return numberFormat.format(Number.parseFloat(value.toString())).replace(',', '.');
};

export const renderPercentage = (value: number | string = 0) => {
  if (value == null) return '';
  const numberFormat = new Intl.NumberFormat('en', {
    style: 'percent',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
  return numberFormat.format(Number.parseFloat(value.toString()));
};
